export default {
  survey: null
}



// WEBPACK FOOTER //
// ./src/store/modules/clientsurvey/state.js